import { getSchoolsList } from "../../../data/models/school.model";
import VueCookies from "vue-cookies";
import { bus } from "@/main";

export default {
	name: "SchoolsPage",
	data() {
		return {
			content: null,
			isReadyContent: false,
			currentPage: 1,
			totalPages: 1,
			totalSchools: null,
		}
	},
	created () {
		this.getContent();
		bus.$on("deleteSession", () => {
			this.getContent();
		})
		bus.$on("userSession", () => {
			this.getContent();
		})
	},
	computed: {
		pageUrl: function() {
			return location.href;
		}
	},
	watch: {
		"$route": function () {
			this.getContent();
		}
	},
	methods: {
		getContent() {
			let user = VueCookies.get("user")
			if (user.username == "admin" || user.username == "projetoescolas") {
				getSchoolsList(1, 1).then( content => {
					this.content = content;
					this.isReadyContent = true;
					this.totalPages = content.totalPages;
					this.totalSchools = content.totalSchools;
				});
			} else {
				getSchoolsList(1, 1, user.id).then( content => {
					this.content = content;
					this.isReadyContent = true;
					this.totalPages = content.totalPages;
					this.totalSchools = content.totalSchools;
				});
			}
		},
		getMoreContent(currentPage) {
			let user = VueCookies.get("user");
			this.content = [];
			this.isReadyContent = false;
			if (user.username == "admin" || user.username == "projetoescolas") {
				getSchoolsList(1, currentPage).then(content => {
					this.content = content;
					this.totalPages = content.totalPages;
					this.totalSchools = content.totalSchools;
					this.currentPage = currentPage;
					this.isReadyContent = true;
				});
			} else {
				getSchoolsList(1, currentPage, user.id).then(content => {
					this.content = content;
					this.totalPages = content.totalPages;
					this.totalSchools = content.totalSchools;
					this.currentPage = currentPage;
					this.isReadyContent = true;
				});
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/schools/schools.page.js